import {  
    getFirestore,
    doc,
    setDoc
} from "firebase/firestore";
const setHealthData = async function(data, userId, docId) {

    let db = getFirestore();

    if( docId == undefined ){
        docId = (new Date()).getTime();
    }
    let ref = doc(db, '/wellness_data/' + userId + '/healthdata/' + docId);
    await setDoc(ref, data, {merge: true} );

};
export default setHealthData;